import { render } from "./range-slider-fallback.vue?vue&type=template&id=b0788f56"
import script from "./range-slider-fallback.vue?vue&type=script&lang=js"
export * from "./range-slider-fallback.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__